import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { TipoOcupacionConfiguracion } from '../../_models/tipo-ocupacion-configuracion';
import { TipoOcupacionConfiguracionService } from '../../_services/tipo-ocupacion-configuracion.service';
import {CreditosDigital} from '../../_enums/enum';

@Component( {
  selector: 'app-tipo-ocupacion-configuracion-detalle',
  templateUrl: 'tipo-ocupacion-configuracion-detalle.component.html'
} )

export class TipoOcupacionConfiguracionDetalleComponent implements OnInit {

  tipOcupacion: TipoOcupacionConfiguracion;
  carInformacionInicial = true;
  tabSeleccionado: string = 'TIPOCU';
  canales  = CreditosDigital;

  constructor( private tipOcupacionConfiguracionServicio: TipoOcupacionConfiguracionService,
               private route: ActivatedRoute, private location: Location ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      this.tipOcupacionConfiguracionServicio.obtenerPorId( params[ 'id' ] ).subscribe( tipOcupacion => {
        this.tipOcupacion = tipOcupacion;
        this.carInformacionInicial = false;
      } );
    } );
  }

  regresar() {
    this.location.back();
  }
  abrirAcordeon(event: any): void {
    const opciones = {
      0: 'TIPOCU',
      1: 'FLUDIG'
    };
    this.tabSeleccionado = opciones[event.index] || 'TIPOCU';
  }
}
